<div *commonUiOptionalWizardStep>

  <div class="mb-5x">
    <h2
      class="mb-3x">{{ 'COMMON_UI.FRAGEBOGEN.ONESTOPSHOP.TITEL' | translate }}
    </h2>

    <div>
      <h3>{{ 'COMMON_UI.FRAGEBOGEN.ONESTOPSHOP.INLAND.TITEL' | translate }}</h3>

      <div class="col-sm-12 col-lg-12 p-0 mb-3x mt-2x">
        <common-ui-card [message]="'COMMON_UI.FRAGEBOGEN.ONESTOPSHOP.INLAND.HINWEIS' | translate"
                        type="info">
        </common-ui-card>
      </div>

      <div class="form-check">
        <input (change)="onInlandAnsaessigkeitsstaatChanged($event)" [(ngModel)]="data.inlandAnsaessigkeitsstaat"
               [disabled]="readonly"
               class="form-check-input" id="inlandAnsaessigkeitsstaat"
               type="checkbox">
        <label class="form-check-label"
               for="inlandAnsaessigkeitsstaat">{{ 'COMMON_UI.FRAGEBOGEN.ONESTOPSHOP.INLAND.ANSAESSIGKEITSSTAAT' | translate }}
        </label>
      </div>

      <div *ngIf="data.inlandAnsaessigkeitsstaat">

        <div class="form-check">
          <input (change)="onInlandKeineNiederlassungEUChanged($event)" [(ngModel)]="data.inlandKeineNiederlassungEU"
                 [disabled]="readonly"
                 class="form-check-input" id="inlandKeineNiederlassungEU"
                 type="checkbox">
          <label class="form-check-label"
                 for="inlandKeineNiederlassungEU">{{ 'COMMON_UI.FRAGEBOGEN.ONESTOPSHOP.INLAND.KEINENL' | translate }}
          </label>
        </div>

        <div *ngIf="data.inlandKeineNiederlassungEU" class="ml-3x">

          <div *ngIf="data.inlandInlandversteuerung && data.inlandInlandversteuerungVerzicht"
               class="col-sm-12 col-lg-12 p-0 mt-2x">
            <common-ui-card [message]="'COMMON_UI.FRAGEBOGEN.ONESTOPSHOP.HINWEIS_DOPPELTEANGABE' | translate" id="hinweisDoppelteAngabeInlandVersteuerung"
                            type="danger">
            </common-ui-card>
          </div>

          <div class="form-check">
            <input [(ngModel)]="data.inlandInlandversteuerung" [disabled]="readonly"
                   class="form-check-input"
                   id="inlandInlandversteuerung" type="checkbox">
            <label class="form-check-label"
                   for="inlandInlandversteuerung">{{ 'COMMON_UI.FRAGEBOGEN.ONESTOPSHOP.INLAND.VERSTEUERUNG' | translate }}
            </label>
          </div>

          <div class="form-check">
            <input (change)="onInlandInlandversteuerungVerzichtChanged($event)" [(ngModel)]="data.inlandInlandversteuerungVerzicht"
                   [disabled]="readonly"
                   class="form-check-input" id="inlandInlandversteuerungVerzicht"
                   type="checkbox">
            <label class="form-check-label"
                   for="inlandInlandversteuerungVerzicht">{{ 'COMMON_UI.FRAGEBOGEN.ONESTOPSHOP.INLAND.VERZICHT' | translate }}
            </label>
          </div>

          <div *ngIf="data.inlandInlandversteuerungVerzicht" class="ml-3x">

            <div *ngIf="data.inlandInlandversteuerungVerzichtBZSt && data.inlandInlandversteuerungVerzichtEU"
                 class="col-sm-12 col-lg-12 p-0 mt-2x">
              <common-ui-card [message]="'COMMON_UI.FRAGEBOGEN.ONESTOPSHOP.HINWEIS_DOPPELTEANGABE' | translate" id="hinweisDoppelteAngabeInlandVerzicht"
                              type="danger">
              </common-ui-card>
            </div>

            <div class="form-check">
              <input [(ngModel)]="data.inlandInlandversteuerungVerzichtBZSt" [disabled]="readonly"
                     class="form-check-input"
                     id="inlandInlandversteuerungVerzichtBZSt" type="checkbox">
              <label class="form-check-label"
                     for="inlandInlandversteuerungVerzichtBZSt">{{ 'COMMON_UI.FRAGEBOGEN.ONESTOPSHOP.INLAND.VERZICHT_BZST' | translate }}
              </label>
            </div>

            <div class="form-check">
              <input [(ngModel)]="data.inlandInlandversteuerungVerzichtEU" [disabled]="readonly"
                     class="form-check-input"
                     id="inlandInlandversteuerungVerzichtEU" type="checkbox">
              <label class="form-check-label"
                     for="inlandInlandversteuerungVerzichtEU">{{ 'COMMON_UI.FRAGEBOGEN.ONESTOPSHOP.INLAND.VERZICHT_EU' | translate }}
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="mt-5x">

      <h3>{{ 'COMMON_UI.FRAGEBOGEN.ONESTOPSHOP.AUSLAND.TITEL' | translate }}</h3>

      <div class="col-sm-12 col-lg-12 p-0 mb-3x mt-2x">
        <common-ui-card [message]="'COMMON_UI.FRAGEBOGEN.ONESTOPSHOP.AUSLAND.HINWEIS' | translate"
                        type="info">
        </common-ui-card>
      </div>

      <div class="form-check">
        <input (change)="onAuslandAnsaessigkeitsstaatChanged($event)" [(ngModel)]="data.auslandAnsaessigkeitsstaat"
               [disabled]="readonly"
               class="form-check-input" id="auslandAnsaessigkeitsstaat"
               type="checkbox">
        <label class="form-check-label"
               for="auslandAnsaessigkeitsstaat">{{ 'COMMON_UI.FRAGEBOGEN.ONESTOPSHOP.AUSLAND.ANSAESSIGKEITSSTAAT' | translate }}
        </label>
      </div>

      <div *ngIf="data.auslandAnsaessigkeitsstaat">

        <div class="form-check">
          <input (change)="onAuslandNiederlassungEUChanged($event)" [(ngModel)]="data.auslandNiederlassungEU"
                 [disabled]="readonly"
                 class="form-check-input" id="auslandNiederlassungEU"
                 type="checkbox">
          <label class="form-check-label"
                 for="auslandNiederlassungEU">{{ 'COMMON_UI.FRAGEBOGEN.ONESTOPSHOP.AUSLAND.KEINENL' | translate }}
          </label>
        </div>

        <div *ngIf="data.auslandNiederlassungEU" class="ml-3x">

          <div *ngIf="data.auslandNiederlassungEUAnsaessigkeitstaatversteuerung && data.auslandNiederlassungEUVerzicht"
               class="col-sm-12 col-lg-12 p-0 mt-2x">
            <common-ui-card [message]="'COMMON_UI.FRAGEBOGEN.ONESTOPSHOP.HINWEIS_DOPPELTEANGABE' | translate" id="hinweisDoppelteAngabeAuslandVersteuerung"
                            type="danger">
            </common-ui-card>
          </div>

          <div class="form-check">
            <input [(ngModel)]="data.auslandNiederlassungEUAnsaessigkeitstaatversteuerung" [disabled]="readonly"
                   class="form-check-input"
                   id="auslandNiederlassungEUAnsaessigkeitstaatversteuerung" type="checkbox">
            <label class="form-check-label"
                   for="auslandNiederlassungEUAnsaessigkeitstaatversteuerung">
              {{ 'COMMON_UI.FRAGEBOGEN.ONESTOPSHOP.AUSLAND.VERSTEUERUNG' | translate }}
            </label>
          </div>

          <div class="form-check">
            <input (change)="onAuslandNiederlassungEUVerzicht($event)" [(ngModel)]="data.auslandNiederlassungEUVerzicht"
                   [disabled]="readonly"
                   class="form-check-input" id="auslandNiederlassungEUVerzicht"
                   type="checkbox">
            <label class="form-check-label"
                   for="auslandNiederlassungEUVerzicht">{{ 'COMMON_UI.FRAGEBOGEN.ONESTOPSHOP.AUSLAND.VERZICHT' | translate }}
            </label>
          </div>

          <div *ngIf="data.auslandNiederlassungEUVerzicht" class="ml-3x">

            <div *ngIf="data.auslandNiederlassungEUVerzichtErklaerungAnsaessigkeitstaat && data.auslandNiederlassungEUVerzichtErklaerungDeutschland"
                 class="col-sm-12 col-lg-12 p-0 mt-2x">
              <common-ui-card [message]="'COMMON_UI.FRAGEBOGEN.ONESTOPSHOP.HINWEIS_DOPPELTEANGABE' | translate" id="hinweisDoppelteAngabeAuslandVerzicht"
                              type="danger">
              </common-ui-card>
            </div>

            <div class="form-check">
              <input [(ngModel)]="data.auslandNiederlassungEUVerzichtErklaerungAnsaessigkeitstaat" [disabled]="readonly"
                     class="form-check-input"
                     id="auslandNiederlassungEUVerzichtErklaerungAnsaessigkeitstaat"
                     type="checkbox">
              <label class="form-check-label"
                     for="auslandNiederlassungEUVerzichtErklaerungAnsaessigkeitstaat">
                {{ 'COMMON_UI.FRAGEBOGEN.ONESTOPSHOP.AUSLAND.VERZICHT_EU' | translate }}
              </label>
            </div>

            <div class="form-check">
              <input [(ngModel)]="data.auslandNiederlassungEUVerzichtErklaerungDeutschland" [disabled]="readonly"
                     class="form-check-input"
                     id="auslandNiederlassungEUVerzichtErklaerungDeutschland" type="checkbox">
              <label class="form-check-label"
                     for="auslandNiederlassungEUVerzichtErklaerungDeutschland">
                {{ 'COMMON_UI.FRAGEBOGEN.ONESTOPSHOP.AUSLAND.VERZICHT_DE' | translate }}
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
